<section aria-labelledby="section-title">
  <div class="row">
    <div class="col-sm-10 col-md-8 col-lg-6 mx-auto container">

      <h2>{{ 'DIPRSRegistration.overview.online.access.title' | translate }}</h2>
      <p [innerHtml]="'DIPRSRegistration.overview.online.access.description' | translate"></p>
      <div class="row td-toolbar">
        <div class="col-sm-6">
          <button type="button" class="btn btn-block td-btn-primary-light"
                  [dipseWebMetricEvent]="'myins:seamless:enrollment:have:an:existing:user:id'"
                  (click)="getCallUAPURL()">{{ 'DIPRSRegistration.overview.online.access.button' | translate }}
          </button>
        </div>
        <div class="col-sm-6">
          <button type="button" class="btn btn-block td-btn-primary-light"
                  [dipseWebMetricEvent]="'myins:seamless:enrollment:set:up:new:myins:login:id'"
                  (click)="goToCustomerIdentify()">{{ 'DIPRSRegistration.overview.new.login.button' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
<dipse-loader></dipse-loader>
